"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.nomineeProfileAccountSchema = exports.nomineeCreateAccountSchema = void 0;
const yup = __importStar(require("yup"));
const AsicAddress_1 = require("./AsicAddress");
const User_1 = require("./User");
exports.nomineeCreateAccountSchema = yup.object().shape({
    companyId: yup.string().required(),
    salutation: User_1.UserSchema.salutation,
    familyName: User_1.UserSchema.familyName,
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    email: User_1.UserSchema.email,
    iso2Code: yup
        .string()
        .required()
        .matches(/^[A-Z]{2}$/),
    dialCode: User_1.UserSchema.dialCode,
    phoneNumber: User_1.UserSchema.phoneNumber,
    dateOfBirth: yup.date(),
    careOf: AsicAddress_1.AsicAddressSchema.careOf,
    flatNumber: User_1.DobAddressSchema.fields.flatNumber,
    streetNumber: User_1.DobAddressSchema.fields.streetNumber,
    streetName: User_1.DobAddressSchema.fields.streetName,
    propertyName: User_1.DobAddressSchema.fields.propertyName,
    streetType: User_1.DobAddressSchema.fields.streetType,
    suburb: User_1.DobAddressSchema.fields.suburb,
    townCity: User_1.DobAddressSchema.fields.townCity,
    city: User_1.DobAddressSchema.fields.city,
    state: User_1.DobAddressSchema.fields.state,
    postcode: User_1.DobAddressSchema.fields.postcode,
    country: User_1.DobAddressSchema.fields.country,
    password: User_1.UserSchema.password,
    confirmPassword: User_1.UserSchema.confirmPassword,
    tncAccepted: yup.boolean().oneOf([true], "Must accept terms & conditions").required("Must accept terms & conditions"),
    privacyPolicyAccepted: yup
        .boolean()
        .oneOf([true], "Must accept privacy policy")
        .required("Must accept privacy policy"),
});
/**
 * Profile-only payload for an invitation accepted through Averer Accounts.
 *
 * The identity step has already proved the address and created the sign-in method, so the
 * profile step carries no password and no password confirmation. Every other field keeps the
 * rule of the password variant above.
 */
exports.nomineeProfileAccountSchema = exports.nomineeCreateAccountSchema.omit(["password", "confirmPassword"]);
//# sourceMappingURL=Nominee.js.map